import { render, staticRenderFns } from "./AccordionBlock.vue?vue&type=template&id=3d44aad2"
import script from "./AccordionBlock.vue?vue&type=script&lang=js"
export * from "./AccordionBlock.vue?vue&type=script&lang=js"
import style0 from "./AccordionBlock.vue?vue&type=style&index=0&id=3d44aad2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports